import { render, staticRenderFns } from "./table.vue?vue&type=template&id=1661cd4e&scoped=true&lang=pug"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1661cd4e",
  null
  
)

export default component.exports